"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _programCard.default;
  }
});
Object.defineProperty(exports, "bootstrapWidget", {
  enumerable: true,
  get: function get() {
    return _actions.bootstrapWidget;
  }
});
Object.defineProperty(exports, "container", {
  enumerable: true,
  get: function get() {
    return _programCard2.default;
  }
});
Object.defineProperty(exports, "getProgramFromMarketplace", {
  enumerable: true,
  get: function get() {
    return _actions.getProgramFromMarketplace;
  }
});
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});

var _programCard = _interopRequireDefault(require("./components/program-card/program-card"));

var _programCard2 = _interopRequireDefault(require("./containers/program-card"));

var _reducer = _interopRequireDefault(require("./lib/reducer"));

var _actions = require("./lib/actions");